import { render, staticRenderFns } from "./AssignCollaboratorModal.vue?vue&type=template&id=2dd7df5e&"
import script from "./AssignCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./AssignCollaboratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports